import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f5db6cfc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5db6cfc')) {
      api.createRecord('f5db6cfc', component.options)
    } else {
      api.reload('f5db6cfc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f5db6cfc&", function () {
      api.rerender('f5db6cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GzPYln3VwOYm/JS/offershelp.vue"
export default component.exports